/**
 * Guardian SPA path map — each page has its own URL.
 */

export const GUARDIAN_PATHS = {
  chat: '/',
  profile: '/profile',
  subscriptions: '/subscriptions',
  incidentReport: '/incident-report',
  myReports: '/my-reports',
  // Departments (docs/guardian/03 §1.5, 2026-10-21).
  department: '/department',
  join: '/join',
  login: '/login',
  register: '/register',
  forgot: '/forgot',
  reset: '/reset',
  // Legal documents (audit P-4, 2026-10-22); public, no auth.
  terms: '/terms',
  privacy: '/privacy',
  model: (id) => `/models/${id}`,
};

const AUTH_PATHS = new Set([
  GUARDIAN_PATHS.login,
  GUARDIAN_PATHS.register,
  GUARDIAN_PATHS.forgot,
  GUARDIAN_PATHS.reset,
]);

/**
 * @param {string} pathname
 * @returns {'login'|'register'|'forgot'|'reset'|null}
 */
export function authModeFromPath(pathname) {
  if (pathname === GUARDIAN_PATHS.login) return 'login';
  if (pathname === GUARDIAN_PATHS.register) return 'register';
  if (pathname === GUARDIAN_PATHS.forgot) return 'forgot';
  if (pathname === GUARDIAN_PATHS.reset) return 'reset';
  return null;
}

/**
 * @param {string} pathname
 * @returns {string} activeView id (chat | profile | subscriptions | incident-report | my-reports |
 *   department | join | model id)
 */
export function viewFromPath(pathname) {
  if (AUTH_PATHS.has(pathname)) return 'chat';
  if (pathname === GUARDIAN_PATHS.profile) return 'profile';
  if (pathname === GUARDIAN_PATHS.subscriptions) return 'subscriptions';
  if (pathname === GUARDIAN_PATHS.incidentReport) return 'incident-report';
  if (pathname === GUARDIAN_PATHS.myReports) return 'my-reports';
  if (pathname === GUARDIAN_PATHS.department) return 'department';
  if (pathname === GUARDIAN_PATHS.join) return 'join';
  if (pathname === GUARDIAN_PATHS.terms) return 'terms';
  if (pathname === GUARDIAN_PATHS.privacy) return 'privacy';
  const modelMatch = pathname.match(/^\/models\/([^/]+)$/);
  if (modelMatch) return decodeURIComponent(modelMatch[1]);
  return 'chat';
}

/**
 * @param {string} view
 * @returns {string}
 */
export function pathFromView(view) {
  if (view === 'chat') return GUARDIAN_PATHS.chat;
  if (view === 'profile') return GUARDIAN_PATHS.profile;
  if (view === 'subscriptions') return GUARDIAN_PATHS.subscriptions;
  if (view === 'incident-report') return GUARDIAN_PATHS.incidentReport;
  if (view === 'my-reports') return GUARDIAN_PATHS.myReports;
  if (view === 'department') return GUARDIAN_PATHS.department;
  if (view === 'join') return GUARDIAN_PATHS.join;
  if (view === 'terms') return GUARDIAN_PATHS.terms;
  if (view === 'privacy') return GUARDIAN_PATHS.privacy;
  if (view && view !== 'chat') return GUARDIAN_PATHS.model(view);
  return GUARDIAN_PATHS.chat;
}

/**
 * @param {'login'|'register'|'forgot'|'reset'} mode
 * @returns {string}
 */
export function pathFromAuthMode(mode) {
  if (mode === 'login') return GUARDIAN_PATHS.login;
  if (mode === 'register') return GUARDIAN_PATHS.register;
  if (mode === 'forgot') return GUARDIAN_PATHS.forgot;
  if (mode === 'reset') return GUARDIAN_PATHS.reset;
  return GUARDIAN_PATHS.login;
}
